import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero, CTABand } from "@/components/PageHero";
import { Section, SectionHeading, InfoBox } from "@/components/Primitives";

const IMG = "https://images.unsplash.com/photo-1774953037913-af0cf688491a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const SERVICES = [
  "Labuan company setup", "Malaysian Sdn. Bhd. company formation through appropriate providers",
  "Representative and regional office support", "Business licensing coordination",
  "Registered office coordination", "Corporate secretarial coordination",
  "Accounting and tax-professional referral", "Banking application preparation",
  "Work-permit coordination", "Market research", "Local partner and distributor search",
  "Import and export support", "Office setup", "Business activation", "Ongoing operational support",
];

export default function MalaysiaServices() {
  return (
    <>
      <SEO title="Malaysia Business Services" description="Malaysian company setup for foreigners, Sdn Bhd formation, licensing, banking preparation and ongoing support. Contact us to know more." path="/malaysia-business-services" />
      <PageHero eyebrow="Malaysia Business Services" image={IMG}
        title="Establish and Operate Your Business in Malaysia"
        subtitle="A complete set of coordination services for entering and operating in Malaysia. Regulated services are delivered by appropriately licensed providers. Contact us to know more." />
      <Section className="bg-white">
        <SectionHeading eyebrow="Our Services" title="What We Coordinate for You" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((s) => (
            <div key={s} className="rounded-xl border border-slate-100 bg-slate-50/60 p-5 flex items-start gap-3 hover-lift">
              <span className="w-6 h-6 rounded-full bg-emerald-brand/10 flex items-center justify-center shrink-0 mt-0.5"><Check size={13} className="text-emerald-brand" /></span>
              <span className="text-sm font-medium text-navy">{s}</span>
            </div>
          ))}
        </div>
        <div className="mt-8"><InfoBox>Regulated services are delivered by appropriately licensed providers. Every business is different — the appropriate approach depends on your circumstances. Contact us to know more.</InfoBox></div>
        <div className="mt-6"><Link to="/eligibility" className="btn-gold rounded-full px-6 py-3 font-bold">Request a Preliminary Assessment</Link></div>
      </Section>
      <CTABand service="Malaysian company setup" serviceKey="malaysia" />
    </>
  );
}
